import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import Img from 'components/Image';
import hexColoredSmall from "utils/images/hex-colored-small.svg"
import WL from 'constants/whiteLabel';
import gs from 'pages/pages.module.css'
import s from 'pages/homeStyles.module.css'
import style from './efficiency.module.css';

const Efficiency = () => (
  <section className={cx(style.root, gs.content, s.hiveosContent, s.alternate)}>
    {WL.showHexImg ? <img alt="hex icon" className={cx(s.drop1, s.__beInControl)} src={hexColoredSmall} /> : null}
    <div className={gs.backgroundHeader}>efficiency</div>
    <div className={cx(gs.wrapper, s.wrapper)}>
      <div className={gs.relative}>
        <div className={style.transfromToRight}>
          <Img className={style.screen} src="efficiency.png" alt="efficiency" />
        </div>
      </div>
      <div className={style.text}>
        <h2><FormattedMessage id="Efficiency.title" defaultMessage="Down to 75W/TH" /></h2>
        <p className={gs.subheader}><FormattedMessage id="Efficiency.caption1" defaultMessage="with undervolting" /></p>
        <div><FormattedMessage id="Efficiency.caption2" defaultMessage="Down to 75W/TH by undervolting and drastically reduce your power consumption." /></div>
        <br />
        <div>
          <FormattedMessage id="Efficiency.caption3" defaultMessage="Voltage change reduces power draw by tuning chips frequency for optimum hashrate and minimum power consumption." />
        </div>
      </div>
    </div>
  </section>
)

export default Efficiency;
